<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item class="query-form-item" label="状态">
                <el-select v-model="query.status" placeholder="全部" @change="onSubmit" clearable>
                    <el-option label="全部" value=""></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="关闭" value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input placeholder="名称" v-model="query.content" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>
            <el-table-column label="选择" prop="orderid" type="selection" :show-overflow-tooltip="true" width="50"
                align="center" />
            <el-table-column label="国家名称(中文)" prop="name" align="center" />
            <el-table-column label="国家名称(英文)" align="center" prop="english" />
            <el-table-column label="状态" align="center" prop="status" width="260">
                <template slot-scope="scope">
                    <el-switch active-color="#13ce66" v-model="scope.row.status" @change="backgroundChange(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
            <el-button type="primary" size="small" @click="delGroup(1)">开启</el-button>
            <el-button type="danger" size="small" @click="delGroup(0)">关闭</el-button>
        </div>
        <el-pagination class="pagination-container" background :page-size="query.pageSize"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.currentPage"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>
    </div>
</template>

<script>
    import {
        getList,
        editStatus
    } from "../../api/setting/statement.js";
    import {
        getmbcountAll
    } from "../../api/product/product";
    export default {
        data() {
            return {
                slidepicid: "",
                slidepictitle: "",
                slidepicsort: "",
                slidepictype: "",
                slidepicaddress: "",
                slidepicsite: "",
                slidestatus: "",
                status: "",
                count: "",
                dialogVisible: false,
                cancelToggle: false,
                servicestarttime: [],
                query: {
                    status: "",
                    content: "",
                    currentPage: 1,
                    pageSize: 10
                },
                list: [],
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formLoading: false,
                formVisible: false,
                formInfo: false,
                formInput: false,
                multipleSelection: [], //多选集合
                pic_is_show: true,
            };
        },
        methods: {
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            //重置搜索
            onRest() {
                Object.assign(this.query, this.$options.data().query)
                this.getList();
            },
            //搜索
            onSubmit() {
                this.query.currentPage = 1
                this.query.pageSize = 10
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },

            getList() {
                this.loading = true;
                getList(this.query)
                    .then(res => {
                        if (res.code) {
                            this.$message.errsor(res.message);
                        }
                        res.data.list.forEach(item => {
                            if (item.status == 1) {
                                item.status = true
                            } else {
                                item.status = false
                            }
                        })
                        this.list = res.data.list;
                        this.totalNumber = res.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            //状态改变
            backgroundChange(row) {
                var status = "";
                if (row.status == true) {
                    status = 1
                } else {
                    status = 0
                }
                var params = {
                    ids: row.id,
                    status: status
                }
                editStatus(params).then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("操作成功");
                    this.getList();
                    this.setcountrys()
                });
            },
            setcountrys() {
                getmbcountAll().then((res) => {
                    let country = []
                    res.data.forEach(item => {
                        country.push({
                            name: item.name,
                            id: item.id,
                            checked: false
                        })
                    })
                    sessionStorage.setItem('opencountry', JSON.stringify(country))
                    //这个缓存用于商品添加/修改选择国家使用
                });
            },
            //批量开启/关闭
            delGroup(type) {
                var ids = this.multipleSelection.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                var data = {
                    ids: ids,
                    status: type
                }
                editStatus(data).then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("操作成功");
                    this.getList();
                });
            },
        },
        created() {
            // 加载表格数据
            this.getList();
        }
    };

</script>

<style type="text/scss" lang="scss">
    body {
  margin: 0;
}
.app_logo {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.loading_div {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
